import {
  Component,
  OnInit,
  ChangeDetectorRef,
  AfterViewInit
} from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { RequestModel } from 'src/app/shopping-cart/request-model.model';
import { ShoppingCartService } from 'src/app/shopping-cart/shopping-cart.service';
import { fileValidator } from 'src/app/validators/file-validator';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import { stateValidator } from 'src/app/validators/state-validator';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { TrimFormControl } from '../trim-control';
import { TouchFormControl } from 'src/app/validation-banner/touch-form-control.modal';
import { MaintenanceService } from 'src/app/maint-service/maintenance.service';
import { KeyValue } from '@angular/common';
import { ProviderTypeService } from 'src/app/prov-service/provider-type.service';
import { RequestTypeService } from 'src/app/req-type/request-type.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { EventService } from 'src/app/main/event-service/event.service';
import { State } from '../state.model';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['../../app.component.scss']
})
export class MaintenanceComponent implements OnInit, AfterViewInit {
  colorTheme = 'theme-dark-blue';
  bsConfig: Partial<BsDatepickerConfig>;
  public myForm: FormGroup;
  public doc: File;
  private _index = null;
  private _request: RequestModel;
  private _duplicated: RequestModel = null;
  public gatewayMed = false;
  private _optDocs: File[] = [];
  private _emitRequest: RequestModel;
  public readonly taxChange = 'TAX CHANGE';
  public faCalendar = faCalendar;
  private _showBanner = false;
  public todayDate = new Date();
  public group = false;
  private _reqToggle = 'new';

  constructor(
    private cartService: ShoppingCartService,
    private ref: ChangeDetectorRef,
    private maintenanceService: MaintenanceService,
    private providerService: ProviderTypeService,
    private requestTypeService: RequestTypeService,
    private modalService: BsModalService,
    private eventService: EventService
  ) {}

  ngAfterViewInit(): void {
    this.myForm.controls['maintenanceType'].setValue(
      this.request
        ? this.request.maintenanceType
        : this.duplicated
        ? this.duplicated.maintenanceType
        : ''
    );
    
    this.reqToggle = this.index != null ? 'update' : 'new';
    this.ref.detectChanges();
  }

  ngOnInit() {
    this.myForm = new FormGroup({
      name: new TrimFormControl('', [
        Validators.required,
        Validators.pattern(/^[A-Za-z0-9\&\-\,\.\/\:\#\'\(\) ]+$/)
      ]),
      middleInitial: new TrimFormControl('', [
        Validators.pattern(/^[A-Za-z]+$/)
      ]),
      lastName: new TrimFormControl('', [
        Validators.required,
        Validators.pattern(/^[A-Za-z0-9\&\-\,\.\/\:\#\'\(\) ]+$/)
      ]),
      idType: new TouchFormControl('NPI', [Validators.required]),
      NPI: new TrimFormControl('', [Validators.required]),
      taxID: new TrimFormControl('', []),
      providerID: new TrimFormControl('', []),
      country: new TrimFormControl('US', [Validators.required]),
      requestDetails: new TrimFormControl('', [Validators.required]),
      doc: new TouchFormControl('', []),
      maintenanceType: new TrimFormControl('', [Validators.required]),
      effDate: new TouchFormControl('', [Validators.required]),
      providerType: new TouchFormControl(''),
      requestType: new TouchFormControl(''),
      optDoc: new TouchFormControl('')
    });

    this.bsConfig = Object.assign({}, { containerClass: this.colorTheme });

    this.index = this.eventService.request;
    this.request = this.cartService.getSingleRequest(this.index);
    this.duplicated = this.eventService.requestModel;

    if (this.index !== null && this.myForm.controls['country'].value === 'US') {
      this.myForm.addControl(
        'state',
        new TrimFormControl('', [Validators.required, stateValidator([])])
      );
      this.optDocs = this.request.optDocs;
    }
    else if (this.duplicated !== null && this.myForm.controls['country'].value === 'US') {
      this.myForm.addControl(
        'state',
        new TrimFormControl('', [Validators.required, stateValidator([])])
      );
    }
    else {
      this.myForm.addControl(
        'state',
        new TrimFormControl('', [Validators.required, stateValidator([])])
      );
    }
  }

  public updateFile(doc: any): void {
    this.doc = doc;
  }

  public updateOptFile(docs: any): void {
    if (docs) {
      this.optDocs = docs;
    }
  }

  public updateRequest(emitRequest: any) {
    this.emitRequest = emitRequest;
  }

  valueAscOrder = (
    a: KeyValue<string, string>,
    b: KeyValue<string, string>
  ): number => {
    return a.value.localeCompare(b.value);
  };

  public closeParent(close?: any): void {
    this.modalService._hideModal();
    this.modalService._hideBackdrop();
    
    let valid = true;

    if (close !== undefined) {
      valid = close;
    }

    this.eventService.confirmEvent.emit(new State(false, valid, this.reqToggle));
  }

  public submit(event: any): void {
    if (this.submittable()) {
      const request = this.myForm.value;
      const type = 'P02';
      request.providerType = this.providerService.provider[type];
      const reqType = 'R01';
      request.requestType = this.requestTypeService.reqType[reqType];
      request.fileType = this.doc ? this.doc.type : '';
      request.doc = this.doc; // this sets the required doc from the file upload
      request.optDocs = this.optDocs; // this sets the optional doc from the file upload

      if (this.emitRequest) {
        request.state = this.emitRequest.state;
        request.gateway = this.emitRequest.gateway
          ? this.emitRequest.gateway
          : false;
      }
      else {
        request.state = null;
        request.gateway = false;
      }

      this.closeParent();
      this.request
        ? this.cartService.editRequest(this.index, request)
        : this.cartService.addToCart(request);
    }
    else if (this.myForm.invalid) {
      this._showBanner = true;
    }
  }

  public submittable(): boolean{
    return this.myForm.touched && this.myForm.valid;
  }

  public handleTypeChange(event): void {
    if (this.myForm.controls['maintenanceType'].value === this.taxChange) {
      this.myForm.controls['doc'].setValidators([
        Validators.required,
        fileValidator()
      ]);
      this.myForm.controls['doc'].updateValueAndValidity();
    }
    else {
      this.myForm.controls['doc'].setValue('');
      this.doc = null;
      this.myForm.controls['doc'].clearValidators();
      this.myForm.controls['doc'].updateValueAndValidity();
    }
  }

  public get duplicated(): RequestModel {
    return this._duplicated;
  }

  public set duplicated(value: RequestModel) {
    this._duplicated = value;
  }

  public get reqToggle() {
    return this._reqToggle;
  }

  public set reqToggle(reqToggle: string) {
    this._reqToggle = reqToggle;
  }

  public get index() {
    return this._index;
  }

  public set index(value) {
    this._index = value;
  }

  public get emitRequest(): RequestModel {
    return this._emitRequest;
  }

  public set emitRequest(value: RequestModel) {
    this._emitRequest = value;
  }

  public get request(): RequestModel {
    return this._request;
  }

  public set request(value: RequestModel) {
    this._request = value;
  }

  public get optDocs(): File[] {
    return this._optDocs;
  }

  public set optDocs(value: File[]) {
    this._optDocs = value;
  }
  
  public get maintenance() {
    return this.maintenanceService.maintenance;
  }

  public get showBanner(): boolean {
    return this._showBanner && this.myForm.touched && !this.myForm.valid;
  }
}
